export default __webpack_public_path__ + "static/media/335480300710cc80a115390a6f8fd59c1578510429900.1fbefda2.webp";